import React from 'react'

import { Col, Form } from '_zari/core'

import { KeyEventUtil } from 'utils'

import { PresupuestoNivel3Select2 } from 'sharedComponents/select2'
import { ClearInputGroup } from 'sharedComponents/utils'

const CodigoPresupuestoFormGroup = ({ iTouched, iError, setFieldValue, iValue }) => {
  const onChange = React.useCallback(
    salida => {
      setFieldValue('codigoPresupuesto', salida.value)
      setFieldValue('codigoPresupuestoInfo', salida.label)
    },
    [setFieldValue]
  )

  const clickClear = React.useCallback(() => {
    setFieldValue('codigoPresupuesto', '')
    setFieldValue('codigoPresupuestoInfo', '')

    setTimeout(() => {
      KeyEventUtil.leaveOnKeyEvent('select-ordencompra-codigoPresupuesto')
    }, 200)
  }, [setFieldValue])

  return (
    <Form.Group>
      <Form.Label text='PRESUPUESTO' htmlFor='input-ordencompra-codigoPresupuesto' md={4} alignRightAt='md' />
      <Col md={8}>
        {iValue ? (
          <ClearInputGroup id='input-ordencompra-codigoPresupuesto' iValue={iValue} clickClear={clickClear} />
        ) : (
          <PresupuestoNivel3Select2 id='select-ordencompra-codigoPresupuesto' onChange={onChange} />
        )}
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(CodigoPresupuestoFormGroup)
